<div [ngClass]="showNotification ? 'show' : 'hide'">
  <div class="banner_notification slide-down" *ngIf="showNotifyBanner">
    <div class="ribbon_notify " *ngFor="let banner of notifyBanners;" [innerHtml]="banner.content | safeHtml">
    </div>
  </div>
</div>